import { AgentChat, AgentToolSource } from "../../../documents"

export type ChatAgentRequest = AgentChat
export type ChatAgentResponse = AgentChat

export type FetchAgentHistoryResponse = AgentChat[]

export type CreateToolSourceRequest = AgentToolSource
